/**
 *
 * B端
 * 
 *
 */

import { commonPromise } from '../index.js'

// 跨域代理前缀
// const API_PROXY_PREFIX = '/api'
const API_PROXY_PREFIX = ''
const BASE_URL = API_PROXY_PREFIX
// const BASE_URL = process.env.VUE_APP_API_BASE_URL

const businessApi = {
  enterpriseEdit: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/edit`, method: 'post' }), // 编辑企业认证信息[tb]
  reverseAudit: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/reverse-audit`, method: 'post' }), // 反审核企业认证信息[tb]

  // 企业认证配置
  getBusinessAuthPage: (params) => commonPromise({ params, url: `${BASE_URL}/admin/enterprise-auth/getAuthPage`, method: 'get' }),
  setBusinessAuthPage: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/setAuthPage`, method: 'post' }),

  // 企业列表
  businessList: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/enterprise-list`, method: 'post' }), // 企业列表分页查询[tb]
  businessStatistics: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/enterprise-statistics`, method: 'post' }), // 企业统计[tb]
  businessExport: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/export-enterprise-list`, method: 'post' }), // 导出企业列表[tb]
  businessUserList: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/enterprise-related-user-list`, method: 'post' }), // 企业关联用户列表分页查询[tb]
  businessPurchaseList: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/enterprise-purchase-detail-list`, method: 'post' }), // 企业集采金额明细列表分页查询[tb]
  businessNameList: (params) => commonPromise({ params, url: `${BASE_URL}/admin/enterprise-auth/enterprise-name-list`, method: 'get' }), // 获取企业名称列表[tb]

  // 集采起售全局设置
  getBusinessStartSale: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/getStartSale`, method: 'post' }), 
  setBusinessStartSale: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/setStartSale`, method: 'post' }),
  getBusinessRule: (params) => commonPromise({ params, url: `${BASE_URL}/admin/enterprise-auth/getStartSaleRule`, method: 'get' }), // 获取集采规则
  setBusinessRule: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/setStartRule`, method: 'post' }), // 保存集采规则

  // 用户信息
  recordList: (data) => commonPromise({ data, url: `${BASE_URL}/admin/enterprise-auth/record-list`, method: 'post' }), // 企业认证记录列表分页查询[tb]

  // 优惠劵同步
  couponSyncList: (data) => commonPromise({ data, url: `${BASE_URL}/coupon/goodsSync/couponPage`, method: 'post' }), // 优惠券候选分页【优惠券同步】
  setCouponSync: (data) => commonPromise({ data, url: `${BASE_URL}/coupon/goodsSync/sync`, method: 'post' }), // 执行优惠券商品同步【优惠券同步】
  getCouponSync: (params) => commonPromise({ params, url: `${BASE_URL}/coupon/goodsSync/audit`, method: 'get' }), // 获取优惠券同步最近操作信息【管理后台操作记录】
}

export default businessApi
